import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from "../../../context/ThemeContext";
import { useAuth } from "../../../context/AuthContext";
import axios from 'axios';
import FormikForm from "../../form/FormikForm";
import {
  Card,
  Button,
  Spin,
  Alert,
  Descriptions,
  Space,
  Tag,
  Typography,
  Row,
  Col,
  Modal,
} from 'antd';
import {
  ArrowLeftOutlined,
  EnvironmentOutlined,
  BuildOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  QrcodeOutlined,
  UserOutlined,
  MoneyCollectOutlined,
  EditOutlined,
  DragOutlined,
  UploadOutlined
} from '@ant-design/icons';
import { trLower, trIncludes } from '../../../utils/trText';

const { Text } = Typography;

const PlatformDetailPage = () => {
  const { id } = useParams();
  const { darkMode } = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [platform, setPlatform] = useState(null);
  const [formModalOpen, setFormModalOpen] = useState(false);
  const [currentFormId, setCurrentFormId] = useState('91');
  const [modalTitle, setModalTitle] = useState('Form');
  const [formTableName, setFormTableName] = useState('');
  const [formUniqueField, setFormUniqueField] = useState('');
  const [currentUniqueValue, setCurrentUniqueValue] = useState(null);
  const [formExtraData, setFormExtraData] = useState({});
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://erp.atmturkiye.com/api';

  useEffect(() => {
    let mounted = true;
    async function fetchDetail() {
      try {
        setLoading(true);
        setError(null);

        const res = await axios.post(`${API_BASE_URL}/list/execute-query/platformlar`, {
          params: { id: Number(id) }
        });
        console.log("res", res);
        if (!mounted) return;
        const platformData = res.data[0] || null;
        console.log("platformData", platformData);
        setPlatform(platformData);
      } catch (e) {
        if (!mounted) return;
        setError(e?.response?.data?.detail || e.message);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchDetail();
    return () => { mounted = false; };
  }, [id]);

  const openFormModal = (formId, title = 'Platformlar', tableName = 'platformlar', uniqueField = 'lokasyon', uniqueValue = null, extraData = {}, overrideFunction = null) => {
    setModalTitle(title);
    setCurrentFormId(formId);
    setFormTableName(tableName);
    setFormUniqueField(uniqueField);
    setCurrentUniqueValue(uniqueValue);
    setFormExtraData({
      ...extraData,
      ...(overrideFunction && { _override_function: overrideFunction })
    });
    setFormModalOpen(true);
  };

  const closeFormModal = () => {
    setFormModalOpen(false);
  };

  const handleFormSuccess = (result) => {
    setFormModalOpen(false);
    window.location.reload();
  };

  const openMasrafModal = () => openFormModal(79, 'Masraf Ekle', 'maliyetler', 'maptriksID');

  const getFieldIcon = (key) => {
    const iconMap = {
      'Platform No': <BuildOutlined />,
      'Lokasyon No': <EnvironmentOutlined />,
      'İl': <EnvironmentOutlined />,
      'İlçe': <EnvironmentOutlined />,
      'Lokasyon': <EnvironmentOutlined />,
      'Kurulum Tarihi': <CalendarOutlined />,
      'Enerji Tarihi': <CalendarOutlined />,
      'QRKod': <QrcodeOutlined />,
      'Ekleyen': <UserOutlined />,
      'Açıklama-pop': <InfoCircleOutlined />,
      'Proje': <BuildOutlined />,
      'Platform Tipi': <BuildOutlined />,
      'Platform Durumu': <BuildOutlined />,
      'Kabin Modeli': <BuildOutlined />,
      'Kabin Firması': <BuildOutlined />,
      'Kabin Sayısı': <BuildOutlined />,
    };
    return iconMap[key] || <InfoCircleOutlined />;
  };

  const getStatusColor = (status) => {
    if (status === null || status === undefined) return 'default';
    if (typeof status !== 'string') return 'default';
    const statusLower = trLower(status);
    if (statusLower.includes('aktif') || statusLower.includes('çalışıyor')) return 'success';
    if (statusLower.includes('pasif') || statusLower.includes('arızalı')) return 'error';
    if (statusLower.includes('bakım')) return 'warning';
    return 'default';
  };

  const formatValue = (key, value) => {
    if (value === null || value === '' || value === undefined) {
      return <Text type="secondary">-</Text>;
    }

    if (trLower(key) === 'platform tipi') {
      const map = { 0: 'Açık Alan', 1: 'Dükkan', 2: 'Lobi', 3: 'İBB', 4: 'Yeni Mah.', 5: 'Genel' };
      const num = typeof value === 'number' ? value : Number(value);
      const label = map.hasOwnProperty(num) ? map[num] : value;
      return <Text>{String(label)}</Text>;
    }
    if (trLower(key) === 'platform durumu') {
      const statusMap = { 0: 'Tanımsız', 1: 'Çok Kötü', 2: 'Kötü', 3: 'Normal', 4: 'İyi', 5: 'Çok İyi' };
      const num = typeof value === 'number' ? value : Number(value);
      const label = (Number.isFinite(num) && statusMap[num] !== undefined) ? statusMap[num] : String(value);
      const colorMap = { 'Tanımsız': 'default', 'Çok Kötü': 'error', 'Kötü': 'error', 'Normal': 'warning', 'İyi': 'success', 'Çok İyi': 'success' };
      const color = colorMap[label] || getStatusColor(label);
      return <Tag color={color}>{label}</Tag>;
    }


    if (trIncludes(key, 'tarih') && value) {
      try {
        const date = new Date(value);
        if (!isNaN(date.getTime())) {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = date.getFullYear();
          return <Text>{`${day}-${month}-${year}`}</Text>;
        }
      } catch (e) {
      }
    }

    if (key === 'QRKod' && value) {
      return (
        <Space>
          <QrcodeOutlined />
          <Text code copyable>{value}</Text>
        </Space>
      );
    }

    return <Text>{String(value)}</Text>;
  };

  const fieldGroups = useMemo(() => {
    if (!platform) return [];

    const groups = [
      {
        fields: ['Proje', 'Platform Tipi', 'Platform Durumu']
      },
      {
        fields: ['Lokasyon No', 'İl', 'İlçe', 'Lokasyon']
      },
      {
        fields: ['Kabin Modeli', 'Kabin Firması', 'Kabin Sayısı']
      },
      {
        fields: ['Kurulum Tarihi', 'Enerji Tarihi']
      },
      {
        fields: ['Açıklama-pop']
      }
    ];

    const allFieldsOrdered = groups
      .flatMap(g => g.fields)
      .filter(field => Object.prototype.hasOwnProperty.call(platform, field));

    const items = allFieldsOrdered.map(field => ({
      key: field,
      label: field,
      children: formatValue(field, platform[field]),
      icon: getFieldIcon(field)
    }));

    return [
      {
        title: 'Tüm Bilgiler',
        icon: <InfoCircleOutlined />,
        items
      }
    ];
  }, [platform]);

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px'
      }}>
        <Space direction="vertical" align="center">
          <Spin size="large" tip="Platform bilgileri yükleniyor..." />
        </Space>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Space direction="vertical" style={{ width: '100%' }}>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => navigate(-1)}
          >
            Geri Dön
          </Button>
          <Alert
            message="Hata Oluştu"
            description={`Platform bilgileri yüklenirken bir hata oluştu: ${error}`}
            type="error"
            showIcon
            action={
              <Button size="small" onClick={() => window.location.reload()}>
                Tekrar Dene
              </Button>
            }
          />
        </Space>
      </div>
    );
  }

  if (!platform) {
    return (
      <div style={{ padding: 24 }}>
        <Space direction="vertical" style={{ width: '100%' }} align="center">
          <Button
            icon={<MoneyCollectOutlined />}
            onClick={openMasrafModal}
          >
            Masraf Ekle
          </Button>
        </Space>
      </div>
    );
  }

  return (
    <div style={{
      padding: 24,
      minHeight: '70vh'
    }}>
      <Card
        bodyStyle={{ padding: 16 }}
        style={{
          marginBottom: 24,
        }}
        title={
          <span>KN {platform['QRKod']} - Platform {platform['Platform No']}</span>
        }
        extra={
          <Space>
            <Button
              icon={<EditOutlined />}
              onClick={() => {
                const platformId = platform['Platform No'];
                if (platformId) {
                  openFormModal(91, 'Düzenle', 'platformlar', 'id', platformId, {}, 'Update');
                }
              }}
            >
              Düzenle
            </Button>
            <Button
              icon={<DragOutlined />}
              onClick={() => {
                const platformId = platform['Platform No'];
                const lokasyon = platform['Lokasyon'];
                if (platformId) {
                  const extraData = {
                    kabin: platformId,
                    nereden_name: lokasyon,
                    kullanici_no: user?.kullanici_no || null
                  };
                  // YENİ taşıma kaydı — platform id'sini kabin_tasima.id olarak
                  // geçmek başka bir taşımanın üzerine yazılmasına yol açıyordu.
                  openFormModal(75, 'Platform Taşıma Formu', 'kabin_tasima', null, null, extraData, 'Insert');
                }
              }}
            >
              Taşı
            </Button>
            <Button
              className={darkMode ? "btn-save-dark" : "btn-save-light"}
              icon={<MoneyCollectOutlined />}
              onClick={() => {
                const lokasyon = platform['Lokasyon No'];
                const extraData = {
                  maptriksID: lokasyon
                };
                console.log("lokasyon", lokasyon);
                openFormModal(79, 'Masraf Ekle', 'maliyetler', 'maptriksID', lokasyon, extraData, "Insert");
              }}
            >
              Masraf Ekle
            </Button>
            <Button
              className={darkMode ? "btn-pivot-dark" : "btn-pivot-light"}
              icon={<UploadOutlined />}
              onClick={() => {
                const lokasyon = platform['Lokasyon No'] || platform['MaptriksID'];
                const extraData = {
                  kullanici_no: user?.kullanici_no || null
                };
                {/* burda minio ya eklenmeli*/}
                openFormModal(66, 'Resim Yükle', 'maptriks_lokasyonlar', 'maptriksID', lokasyon, extraData);
              }}
            >
              Resim Yükle
            </Button>
            <Button
              className={darkMode ? "btn-danger-dark" : "btn-danger-light"}
              onClick={() => {
                const platformId = platform['Platform No'];
                const extraData = {
                  kullanici_no: user?.kullanici_no || null
                };
                openFormModal(219, 'Kontrol', 'kurulum_bilgileri', 'platformID', platformId, extraData);
              }}
            >
              Kontrol  {/* değişiklik sağlanmalı */} 
            </Button>
          </Space>
        }
      >
      </Card>

      <Row gutter={[24, 24]}>
        {fieldGroups.map((group, index) => (
          <Col xs={24} lg={24} key={index}>
            <Card
              title={
                <Space>
                  {group.icon}
                  <span>{group.title}</span>
                </Space>
              }
              size="small"
              style={{ height: '100%' }}
            >
              <Descriptions
                bordered
                column={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2 }}
                size="small"
                items={group.items.map(item => ({
                  key: item.key,
                  label: (
                    <Space>
                      {item.icon}
                      <Text strong>{item.label}</Text>
                    </Space>
                  ),
                  children: item.children
                }))}
              />
            </Card>
          </Col>
        ))}
      </Row>
      {formModalOpen && (
        <Modal
          title={modalTitle}
          open={formModalOpen}
          onCancel={closeFormModal}
          footer={null}
          destroyOnHidden={true}
          width={800}
        >
          <div style={{ maxHeight: 600, overflowY: 'auto' }}>
            <FormikForm
              formId={currentFormId}
              uniqueValue={currentUniqueValue}
              uniqueField={formUniqueField}
              tableName={formTableName}
              extraData={formExtraData}
              onSuccess={handleFormSuccess}
            />
          </div>
        </Modal>
      )}
    </div>
  );
}
export default PlatformDetailPage;